import { async } from "@angular/core/testing";
import { Empresa } from "./../../models/empresa";
import { Usuario } from "./../../models/usuario";
import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { URL_SERVICIOS } from "src/app/config/config";

import "rxjs/add/operator/map";

@Injectable({
  providedIn: "root",
})
export class UsuarioService {
  usuarioLogin: Usuario;
  idempresa: string;
  emailempresa: string;
  empresaUsuario = "";
  nombreempresa: string;
  token: string;
  nombredelusuario: string;
  administrador: boolean;
  idusuario: string;
  colorpersonal: string;
  alias: string;
  servidormtto: false;
  usuariomxatencion: string;

  firmatemporaldia = false;
  firmatemporalsem = false;
  firmatemporalmes = false;
  firmatemporalano = false;
  firmatemporalexc = false;

  constructor(public http: HttpClient) {}

  crearUsuario(usuario: Usuario) {
    let url = URL_SERVICIOS + "/usuario";
    return this.http.post(url, usuario).map((resp: any) => {
      alert(
        "Your information has been received.  You will be notified by email once you are authorized"
      );
    });
  }

  altadeusuarios(usuario: Usuario) {
    let url = URL_SERVICIOS + "/usuario";
    return this.http.post(url, usuario).map((resp: any) => {
      // alert ('Your information has been received.  You will be notified by email once you are authorized222');
    });
  }

  crearUsuarioformulario(usuario: Usuario) {
    let url = URL_SERVICIOS + "/usuario/capturainfo";
    return this.http.post(url, usuario).map((resp: any) => {
      alert(
        "Your information has been received.  You will be notified by email once you are authorized"
      );
    });
  }

  login(usuario: Usuario, recordar: boolean = false) {
    let url = URL_SERVICIOS + "/login";
    return this.http.post(url, usuario).map((resp: any) => {
      if (resp.ok) {
        //   console.log('service', resp);
        this.idempresa = resp.id;
        (this.empresaUsuario = resp.empresa),
          (this.emailempresa = resp.emailempresa);
        this.nombreempresa = resp.nombrempresa;
        this.nombredelusuario = resp.usuario.apellido;
        this.alias = resp.usuario.alias;
        this.idusuario = resp.usuario._id;
        this.administrador = resp.usuario.admin;
        this.colorpersonal = resp.usuario.color;
        this.usuariomxatencion = resp.datosempresa.usermx;
        this.servidormtto = resp.servidormtto;

        this.firmatemporaldia = resp.datosempresa.firmatemporaldia;
        this.firmatemporalsem = resp.datosempresa.firmatemporalsem;
        this.firmatemporalmes = resp.datosempresa.firmatemporalmes;
        this.firmatemporalano = resp.datosempresa.firmatemporalano;
        this.firmatemporalexc = resp.datosempresa.firmatemporalexc;

        this.usuarioLogin = resp.usuario;
        //    console.log('respuesta del usuario', resp.usuario);
        localStorage.setItem("id", resp.id);
        localStorage.setItem("iduser", resp.usuario._id);
        localStorage.setItem("userol", resp.usuario.role);
        localStorage.setItem("token", resp.token);
        localStorage.setItem("validarformato", resp.validaformato);
        localStorage.setItem("servidormtto", resp.servidormtto);
        localStorage.setItem("servidormttotxt", resp.servidormttotexto);
        this.token = resp.token;
        localStorage.setItem("usuario", JSON.stringify(resp.usuario));

        if (recordar) {
          localStorage.setItem("emailRecordado", usuario.emailpersonal);
        } else {
          localStorage.removeItem("emailRecordado");
        }

        return resp.empresa;
      } else {
       // return resp.ok;
         alert("user or password invalid!!");
      }
    });
  }

  listadototal() {
    let url = URL_SERVICIOS + "/usuario/listados";
    return this.http.get(url).map((resp: any) => resp.usuario);
  }

  despliegausuario(cveusuario: string) {
    let url = URL_SERVICIOS + "/usuario/localizausuario/" + cveusuario;
    return this.http.get(url).map((resp: any) => resp.usuario);
  }

  listadototalusuariosmx() {
    let url = URL_SERVICIOS + "/usuario/listadosmx";
    return this.http.get<any>(url);
  }

  actualizaUsuarios(datosparaguardar: Usuario, id) {
    // console.log ( 'informacion', datosparaguardar );
    let url = URL_SERVICIOS + "/usuario/" + id;
    return this.http.put(url, datosparaguardar).map((resp: any) => {
      return true;
    });
  }

  guardaSonidoNotificacion(id: string, archivo: File) {
    const formData = new FormData();
    formData.append("sonido", archivo, archivo.name);
    const token = localStorage.getItem("token") || "";
    const url = URL_SERVICIOS + "/usuario/sonido/" + id + "?token=" + encodeURIComponent(token);
    return this.http.put<any>(url, formData);
  }

  restauraSonidoNotificacion(id: string) {
    const token = localStorage.getItem("token") || "";
    const url = URL_SERVICIOS + "/usuario/sonido/" + id + "?token=" + encodeURIComponent(token);
    return this.http.delete<any>(url);
  }

  actualiza_bot(datosparaguardar: Usuario, id) {
    // console.log ( 'informacion', datosparaguardar );
    let url = URL_SERVICIOS + "/bot_actualizacion/" + id;
    return this.http.put(url, datosparaguardar).map((resp: any) => {
      return true;
    });
  }

  actualizastatusbotadmin(id: string, status: string, folio: string) {
    let url =
      URL_SERVICIOS +
      "/usuario/actualizastatusbotadmin/" +
      id +
      "/" +
      status +
      "/" +
      folio;
    return this.http.get(url).map((resp: any) => {
      return resp;
    });
  }

  actualizastatus(id: string, status: string, folio: string) {
    let url =
      URL_SERVICIOS +
      "/usuario/actualizastatus/" +
      id +
      "/" +
      status +
      "/" +
      folio;
    return this.http.get(url).map((resp: any) => {
      return resp;
    });
  }

  actualizastatustarea(id: string, status: string) {
    let url =
      URL_SERVICIOS + "/usuario/actualizastatusfinalizado/" + id + "/" + status;
    return this.http.get(url).map((resp: any) => {
      return resp;
    });
  }

  cambiastatus(id: string, status: string) {
    let url = URL_SERVICIOS + "/usuario/cambiastatusbot/" + id + "/" + status;
    return this.http.get(url).map((resp: any) => {
      return resp;
    });
  }

  // este se ocupa en e;l ticjket paa localziar lso usuarios
  LocalizaInfoUsuarios(id: string) {
    let url = URL_SERVICIOS + "/usuario/listausuarios";
    return this.http.get(url).map((resp: any) => resp.usuario);
  }

  isAutenticado() {
    return this.token != null;
  }

  listadototalusuariosxempresa(id) {
    let url = URL_SERVICIOS + "/usuario/listausuarios/" + id;
    return this.http.get(url).map((resp: any) => resp.usuario);
  }

  encuentrainfodelusuariomx() {}
}
